module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M2.016 0A2.012 2.012 0 0 0 0 2v28c0 1.106.91 2 2.016 2H4V0H2.016zm24 0H6v32h20.016A1.985 1.985 0 0 0 28 30V2c0-1.106-.878-2-1.984-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/journal-1.js
// module id = 1197
// module chunks = 14